export function yandexMap() {
    const $map = document.getElementById('map');

    if ($map) {
        const lat             = $map.dataset.lat;
        const lng             = $map.dataset.lng;
        const w               = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const iconImageSize   = w >= 768 ? [34, 53] : [46, 70];
        const iconImageOffset = w >= 768 ? [-15, -50] : [-20, -70];

        ymaps.ready(function () {
            let myMap = new ymaps.Map($map, {
                center: [lat, lng],
                zoom: 15,
                controls: []
            }, {
                searchControlProvider: 'yandex#search'
            });

            function getPlacemark() {
                return new ymaps.Placemark(myMap.getCenter(), {}, {
                    // Опции.
                    // Необходимо указать данный тип макета.
                    iconLayout: 'default#image',
                    // Своё изображение иконки метки.
                    iconImageHref: '/app/src/img/map-tag.svg',
                    // Размеры метки.
                    iconImageSize: iconImageSize,
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    iconImageOffset: iconImageOffset
                });
            }

            myMap.geoObjects.add(getPlacemark());

            window.myMap = myMap;
            window.getPlacemark = getPlacemark;
        });
    }
}